import { useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import bannerimage from "../assets/ops-banner.svg";
import {
  Circle,
  CircleOff,
  CircleX,
  Download,
  PrinterIcon,
} from "lucide-react";
export default function PayslipModal({ data, onClose }) {
  const pdfRef = useRef();
  const [loading, setLoading] = useState(false);

  const downloadPDF = async () => {
    try {
      setLoading(true);

      const pages = pdfRef.current.querySelectorAll(".pdf-page");
      const pdf = new jsPDF("p", "mm", "a4");

      for (let i = 0; i < pages.length; i++) {
        const canvas = await html2canvas(pages[i], {
          scale: 2,
          useCORS: true,
          backgroundColor: "#ffffff",
        });

        const imgData = canvas.toDataURL("image/png");

        if (i !== 0) pdf.addPage();

        pdf.addImage(imgData, "PNG", 0, 0, 210, 297);
      }

      pdf.save("payslip.pdf");
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const printPDF = async () => {
    const pages = pdfRef.current.querySelectorAll(".pdf-page");

    const pdf = new jsPDF("p", "mm", "a4");

    for (let i = 0; i < pages.length; i++) {
      const canvas = await html2canvas(pages[i], {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const imgData = canvas.toDataURL("image/png");

      if (i !== 0) pdf.addPage();

      pdf.addImage(imgData, "PNG", 0, 0, 210, 297);
    }

    const blobURL = pdf.output("bloburl");

    const printWindow = window.open(blobURL);

    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
    };
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center">
      <div className="bg-white w-[1000px] max-h-[95vh] overflow-auto rounded-xl">
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="font-semibold text-lg">Payslip Preview</h2>

          <div className="flex gap-3">
            <button
              onClick={printPDF}
              className="bg-sky-600 hover:bg-sky-700 text-white px-4 py-2 rounded"
            >
              <PrinterIcon size={20} color="white" />
            </button>

            <button
              onClick={downloadPDF}
              className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
            >
              <Download size={20} color="white" />
            </button>

            <button
              onClick={onClose}
              className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded"
            >
              <CircleX />
            </button>
          </div>
        </div>
        {loading && (
          <div className="absolute inset-0 bg-white/70 flex items-center justify-center z-50">
            <div className="flex flex-col items-center gap-3">
              <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
              <p className="text-sm font-medium">Generating PDF...</p>
            </div>
          </div>
        )}
        <div
          ref={pdfRef}
          className="flex flex-col items-center gap-6 p-6 bg-gray-200"
        >
          <PayslipPage1 data={data} />
        </div>
      </div>
    </div>
  );
}
function PayslipPage1({ data }) {
  return (
    <div
      className="pdf-page bg-white  flex flex-col justify-between"
      style={{
        width: "794px",
        minHeight: "1123px",
        padding: "30px",
        fontSize: "10px",
      }}
    >
      <div className="">
        {/* HEADER */}
        <div className="flex justify-between items-center mb-6">
          {/* <h1 className="text-3xl font-bold tracking-wide">DELHIVERY</h1> */}
          <img src={bannerimage} alt="ops-logo" className=" " />
          {/* <div className="font-semibold text-sm">Delhivery Limited</div> */}
        </div>

        {/* EMPLOYEE DETAILS */}
        <table className="w-full border border-gray-300 mb-2">
          <tbody>
            <tr>
              <td className="border p-1">Employee ID</td>
              <td className="border p-1">{data.employeeId}</td>

              <td className="border p-1">Bank Name</td>
              <td className="border p-1">{data.bankName}</td>
            </tr>

            <tr>
              <td className="border p-1">Employee Name</td>
              <td className="border p-1">{data.employeeName}</td>

              <td className="border p-1">Bank A/C No</td>
              <td className="border p-1">{data.bankAccount}</td>
            </tr>

            <tr>
              <td className="border p-1">Date of Joining</td>
              <td className="border p-1">{data.doj}</td>

              <td className="border p-1">Group DOJ</td>
              <td className="border p-1">{data.groupDoj}</td>
            </tr>

            <tr>
              <td className="border p-1">Bank IFSC Code</td>
              <td className="border p-1">{data.ifsc}</td>

              <td className="border p-1">Designation</td>
              <td className="border p-1">{data.designation}</td>
            </tr>

            <tr>
              <td className="border p-1">Universal Account Number</td>
              <td className="border p-1">{data.uan}</td>

              <td className="border p-1">Department</td>
              <td className="border p-1">{data.department}</td>
            </tr>

            <tr>
              <td className="border p-1">PF No.</td>
              <td className="border p-1">{data.pfNo}</td>

              <td className="border p-1">Work Location</td>
              <td className="border p-1">{data.location}</td>
            </tr>

            <tr>
              <td className="border p-1">ESI No</td>
              <td className="border p-1">{data.esiNo}</td>

              <td className="border p-1">No of Days / LOP / LOPR</td>
              <td className="border p-1">
                {data.days} / {data.lop} / {data.lopr}
              </td>
            </tr>

            <tr>
              <td className="border p-1">Arrear Paid Days</td>
              <td className="border p-1">{data.arrearDays}</td>

              <td className="border p-1"></td>
              <td className="border p-1"></td>
            </tr>
          </tbody>
        </table>

        {/* MONTH */}
        <div className="font-semibold mb-2 p-1 text-xs bg-gray-100">
          Payslip for the month of {data.month} {data.year}
        </div>

        {/* SALARY TABLE */}
        <table className="w-full border border-gray-300 ">
          <thead className="bg-gray-100">
            <tr>
              <th className="border p-1 text-left">Earnings</th>
              <th className="border p-1 text-right">Reference Amount</th>
              <th className="border p-1 text-right">Amount</th>
              <th className="border p-1 text-right">Arrear Amount</th>
              <th className="border p-1 text-right">Year to Date</th>

              <th className="border p-1 text-left">Deductions</th>
              <th className="border p-1 text-right">Amount</th>
              <th className="border p-1 text-right">Year to Date</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className="border p-1">Basic</td>
              <td className="border p-1 text-right">{data.basic}</td>
              <td className="border p-1 text-right">{data.basic}</td>
              <td className="border p-1 text-right">0</td>
              <td className="border p-1 text-right">{data.basicYTD}</td>

              <td className="border p-1">Profession Tax</td>
              <td className="border p-1 text-right">{data.professionTax}</td>
              <td className="border p-1 text-right">{data.professionTaxYTD}</td>
            </tr>

            <tr>
              <td className="border p-1 ">H.R.A</td>
              <td className="border p-1 text-right">{data.hra}</td>
              <td className="border p-1 text-right">{data.hra}</td>
              <td className="border p-1 text-right">0</td>
              <td className="border p-1 text-right">{data.hraYTD}</td>

              <td className="border p-1">Provident Fund (PF)</td>
              <td className="border p-1 text-right">{data.pf}</td>
              <td className="border p-1 text-right">{data.pfYTD}</td>
            </tr>

            <tr>
              <td className="border p-1 ">Special Allowance</td>
              <td className="border p-1 text-right">{data.allowance}</td>
              <td className="border p-1 text-right">{data.allowance}</td>
              <td className="border p-1 text-right">0</td>
              <td className="border p-1 text-right">{data.allowanceYTD}</td>

              <td className="border p-1">Labour Welfare Fund</td>
              <td className="border p-1 text-right">{data.labourFund}</td>
              <td className="border p-1 text-right">{data.labourFundYTD}</td>
            </tr>

            <tr>
              <td className="border p-1">Statutory Bonus</td>
              <td className="border p-1 text-right">{data.bonus}</td>
              <td className="border p-1 text-right">{data.bonus}</td>
              <td className="border p-1 text-right">0</td>
              <td className="border p-1 text-right">{data.bonusYTD}</td>

              <td className="border p-1">EWF</td>
              <td className="border p-1 text-right">{data.ewf}</td>
              <td className="border p-1 text-right">{data.ewfYTD}</td>
            </tr>

            <tr>
              <td className="border p-1">Incentive</td>
              <td className="border p-1 text-right">{data.incentive}</td>
              <td className="border p-1 text-right">{data.incentive}</td>
              <td className="border p-1 text-right">0</td>
              <td className="border p-1 text-right">{data.incentiveYTD}</td>

              <td className="border p-1">LWF adjustment</td>
              <td className="border p-1 text-right">{data.lwfAdjust}</td>
              <td className="border p-1 text-right">{data.lwfAdjustYTD}</td>
            </tr>
          </tbody>
        </table>

        {/* NET PAY */}

        <div className="border border-t-0 font-semibold p-1  bg-gray-100">
          Net Pay : {data.netPay}
        </div>

        <div className="p-1 border-t-0 border bg-gray-100">
          Net Pay In Words : {data.netPayWords}
        </div>

        {/* PF DETAILS */}

        <table className="w-full border mt-2">
          <thead className="bg-gray-100">
            <tr>
              <th className="border p-1 text-left">
                Provident Fund(PF) Details
              </th>

              <th className="border p-1 text-right">Amount</th>

              <th className="border p-1 text-right">Year to Date</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className="border p-1">Employee Contribution to PF</td>
              <td className="border p-1 text-right">{data.pfEmployee || 0}</td>
              <td className="border p-1 text-right">
                {data.pfEmployeeYTD || 0}
              </td>
            </tr>

            <tr>
              <td className="border p-1">Employee VPF Contribution</td>
              <td className="border p-1 text-right">{data.vpf}</td>
              <td className="border p-1 text-right">{data.vpfYTD}</td>
            </tr>

            <tr>
              <td className="border p-1">Employer Contribution to EPS</td>
              <td className="border p-1 text-right">{data.eps}</td>
              <td className="border p-1 text-right">{data.epsYTD}</td>
            </tr>

            <tr>
              <td className="border p-1">Employer Contribution to PF</td>
              <td className="border p-1 text-right">{data.employerPF}</td>
              <td className="border p-1 text-right">{data.employerPFYTD}</td>
            </tr>
          </tbody>
        </table>

        <div className="text-xs mt-6">
          Note : This is a computer generated statement and does not require
          authentication.
        </div>
      </div>
      <div className="border-t py-6 text-[12px] text-gray-700 flex justify-between items-center">
        {/* LEFT SIDE */}
        <div className="max-w-[60%] leading-5">
          {/* <p className="font-semibold">Odisha Parcel Service Limited</p> */}
          <p>
            Registered Office: PLOT NO-701/5403, LANE-1, PATITAPABANA NAGAR,
          </p>
          <p>Badagarh Brit Colony, Bhubaneswar, Khorda-751018, Orissa</p>
        </div>

        {/* VERTICAL LINE */}
        <div className="border-l h-16 mx-6"></div>

        {/* RIGHT SIDE */}
        <div className="leading-5 text-right">
          <p>CIN: U53200OD2024PTC047585</p>
          {/* <p>+91 124 6225600</p> */}
          <p>customersupport@odishaparcel.com</p>
          <p>www.odishaparcel.com</p>
        </div>
      </div>
    </div>
  );
}
